/**
 * Voice-assistant session hook.
 *
 * Fetches a short-lived browser session token from the generic backend
 * endpoint `POST /api/voice/web-session/`. The token is the only credential
 * the browser ever sees; the provider's secret API key stays server-side.
 *
 * Vendor-neutral by design: nothing here names the underlying voice provider.
 * The widget calls `fetchVoiceSession()` and hands the returned token to the
 * voice SDK. Uses the admin axios client (envelope already unwrapped to
 * `res.data`), matching the shared-workflows client precedent; a consumer
 * surface can swap the client without touching the widget.
 */

import api from '@/admin/lib/api'

export interface VoiceSession {
  access_token: string
}

/**
 * Mint a voice session. Resolves to `{ access_token }` on success.
 * Throws on failure (e.g. 503 when the assistant is not configured) so the
 * caller can surface a friendly message.
 */
export async function fetchVoiceSession(): Promise<VoiceSession> {
  const res = await api.post<VoiceSession>('/voice/web-session/', {})
  return res.data
}
